import * as React from "react";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";

import {AppState} from "../store/app_state";
import {createAuthDispatcher, IAuthDispatcher} from "../dispatcher/auth_dispatcher";
import {createAuthActionCreator} from "../action/auth_action";

import {PasswordResetRequest} from "../request/auth_request";
import AuthPasswordResetComponent from "../component/auth/auth_password_reset";

interface IProps {
    dispatcher: IAuthDispatcher;
}

interface IState {
    isInit: boolean;
}

// authコンテナーではない理由がわからない
export class PasswordReset extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

    };

    public render (): JSX.Element {

        let res: JSX.Element;

        res = <AuthPasswordResetComponent handlePasswordResetSubmit={this.handleSubmit}/>

        return (res)
    }

    private handleSubmit = (values: any): void => {
        const req: PasswordResetRequest = new PasswordResetRequest();
        req.email = values.email;
        this.props.dispatcher.resetPassword(req);

    }
}

const mapStateToProps = (state: AppState) => {
    return {
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createAuthDispatcher(dispatch, createAuthActionCreator()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);



// WEBPACK FOOTER //
// ./src/presentation/container/password_reset_container.tsx